import { css } from '@emotion/react';
import { extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { Variants } from 'motion/react';

export const listItemAnimationVariants: Variants = {
  initial: { opacity: 0, y: 10 },
  animate: {
    opacity: 0,
    y: 10,
  },
  inView: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.66, ease: [0.22, 0.9, 0.53, 1] },
  },
};

const styles = {
  item: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 300px;
    padding: 8px 8px 8px 16px;
    border-radius: 8px;
    gap: 2px;
    user-select: none;

    cursor: pointer;

    ${extractTransition((f) => f.cubic, { property: 'background-color', duration: 0.33 })}

    &:hover {
      background-color: ${theme.colors.neutral.variant[5]};
    }
  `,
  selected: ({ theme }) => css`
    &,
    &:hover {
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
  title: css`
    white-space: nowrap;
  `,
  group: css`
    display: flex;
    flex-direction: column;
    padding: 0 6px;
  `,
  skeleton: css`
    pointer-events: none;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
